import { InheritanceTrust } from "@prisma/client-generated";
import { z } from "zod";

export const inheritanceAndTrustSchemaCreate = z.object({
  category: z.nativeEnum(InheritanceTrust),
  nameOfTrust: z.string(),
  benefactor: z.string().nullish(),
  description: z.string().nullish(),
  valueInCents: z.number().min(0),
  currency: z.string().nullish(),
  isJoint: z.boolean().optional(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const inheritanceAndTrustSchemaUpdate =
  inheritanceAndTrustSchemaCreate.partial();

export type InheritanceAndTrustUpsertData = z.infer<
  typeof inheritanceAndTrustSchemaUpdate
> & { id?: string | undefined };
